export interface ProjectDevelopmentMetricsDetails {
  id: number;
  subject: string;
  tracker: string;
  estimated_hours: number;
  registered_hours: number;
  children: Array<ProjectDevelopmentMetricsDetails>;
}

export function ProjectDevelopmentMetricsDetailsFromJSON(
  json: any,
): ProjectDevelopmentMetricsDetails {
  return {
    id: json["id"],
    subject: json["subject"],
    tracker: json["tracker"],
    estimated_hours: json["estimated_hours"],
    registered_hours: json["registered_hours"],
    children: (json["children"] ?? []).map(
      ProjectDevelopmentMetricsDetailsFromJSON,
    ),
  };
}

export interface ProjectDevelopmentMetrics {
  id: number;
  subject: string;
  from_time: Date;
  to_time: Date;
  estimated_time: number;
  total_estimated_time: number;
  development_time: number;
  details: Array<ProjectDevelopmentMetricsDetails>;
}

export function ProjectMetricsFromJSON(json: any): ProjectDevelopmentMetrics {
  return {
    id: json["id"],
    subject: json["subject"],
    from_time: new Date(json["from_time"]),
    to_time: new Date(json["to_time"]),
    estimated_time: json["estimated_time"],
    total_estimated_time: json["total_estimated_time"],
    development_time: json["development_time"],
    details: (json["details"] ?? []).map(
      ProjectDevelopmentMetricsDetailsFromJSON,
    ),
  };
}
